module.exports = __webpack_public_path__ + "img/painting-color.6142d435.png";